var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gantt"},[_c('div',{ref:"gantt",staticClass:"gantt__container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }